import { buildAvatarStyle, buildIniciales } from '../../shared/helpers/map-congregacion-row';
import { formatNombreCompletoDisplay } from '../../shared/helpers/nombre-texto.helper';
import { MuellePersona } from '../../shared/interfaces/muelle.interface';
import { PersonTableRow } from '../../shared/interfaces/person-table.interface';

const NADIE = 'nadie';

export function mapMuelleRow(persona: MuellePersona, yoId: string): PersonTableRow {
  const contactadoId = (persona.contactadoId ?? '').trim() || NADIE;
  const mio = !!yoId && contactadoId === yoId;
  const nadie = contactadoId === NADIE;
  const nombre = formatNombreCompletoDisplay(persona.nombre);

  let celular = 'Oculto';
  let whatsappUrl: string | null = null;
  if (mio) {
    const raw = `${persona.celular ?? ''}`.trim();
    if (!raw) {
      celular = 'Dato vacío';
    } else {
      celular = raw;
      const digits = `${persona.prefijo ?? ''}${raw}`.replace(/\D/g, '');
      whatsappUrl = digits ? `https://wa.me/${digits}` : null;
    }
  } else if (!nadie) {
    const quien = (persona.contactadoNombre ?? '').trim() || '—';
    celular = `Contactado por: ${quien}`;
  }

  const ciudad = (persona.ciudad ?? '').trim();

  return {
    id: persona.id,
    nombreCompleto: formatNombreCompletoDisplay(persona.nombre, persona.nombre2, persona.apellido),
    iniciales: buildIniciales(persona.nombre, persona.apellido),
    avatarStyle: buildAvatarStyle(persona.sexo),
    esLider: persona.lider === true,
    esAdmin: false,
    esContador: false,
    nacimiento: persona.nacimiento ?? null,
    edadLabel: '—',
    miLider: '—',
    celular,
    prefijo: persona.prefijo ?? '',
    whatsappUrl,
    ciudad: ciudad || 'Dato vacío',
    faltasLabel: '',
    estadoLabel: '',
    cumpleEnLabel: '',
    motivoLabel: '',
    reunionLabel: '',
    contactadoId,
    nombre,
    apellido: persona.apellido,
    sinMenu: !mio && !nadie,
  };
}
